// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `properties-srarch-form {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  height: 100%;
}
properties-srarch-form .addBtn {
  background-color: rgb(59, 209, 59) !important;
  color: whitesmoke !important;
  width: 26px;
  height: 26px;
  line-height: 26px;
}
properties-srarch-form .views {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  height: 100%;
}
properties-srarch-form .views .view {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
}
properties-srarch-form .views .view > .header {
  flex: 0 1 auto;
  height: 64px;
  min-height: 64px;
  border-bottom: 1px solid;
}
properties-srarch-form .views .view > .content {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
properties-srarch-form .views .view > .content .mat-mdc-form-field-wrapper {
  padding: 0;
}

fuse-sidebar.extend-panel {
  width: 80%;
  min-width: 80%;
  max-width: 80%;
}
@media screen and (max-width: 599px) {
  fuse-sidebar.extend-panel {
    min-width: 0 !important;
    max-width: 100vw !important;
    width: 100vw !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/main/properties/components/search-form/search-form.component.scss","webpack://./src/@fuse/scss/partials/_breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AADJ;AAGI;EACI,6CAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAFR;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;AAFZ;AAOY;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;AALhB;AAQY;EACI,cAAA;EACA,gBAAA;EACA,iCAAA;AANhB;AAOgB;EACI,UAAA;AALpB;;AAaI;EACI,UAAA;EACA,cAAA;EACA,cAAA;AAVR;ACjBQ;EDwBJ;IAMQ,uBAAA;IACA,2BAAA;IACA,uBAAA;EATV;AACF","sourcesContent":["@import \"src/@fuse/scss/partials/breakpoints\";\n\nproperties-srarch-form {\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n    height: 100%;\n\n    .addBtn {\n        background-color: rgb(59, 209, 59) !important;\n        color: whitesmoke !important;\n        width: 26px;\n        height: 26px;\n        line-height: 26px;\n    }\n\n    .views {\n        display: flex;\n        flex-direction: column;\n        position: relative;\n        overflow: hidden;\n        height: 100%;\n\n        .view {\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            top: 0;\n            display: flex;\n            flex-direction: column;\n\n            // width: 280px;\n            // min-width: 280px;\n            // max-width: 280px;\n            >.header {\n                flex: 0 1 auto;\n                height: 64px;\n                min-height: 64px;\n                border-bottom: 1px solid;\n            }\n\n            >.content {\n                flex: 1 1 auto;\n                overflow-y: auto;\n                -webkit-overflow-scrolling: touch;\n                .mat-mdc-form-field-wrapper {\n                    padding: 0\n                }\n            }\n        }\n    }\n}\n\nfuse-sidebar {\n    &.extend-panel {\n        width: 80%;\n        min-width: 80%;\n        max-width: 80%;\n\n        @include media-breakpoint(\"xs\") {\n            min-width: 0 !important;\n            max-width: 100vw !important;\n            width: 100vw !important;\n        }\n    }\n}","// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
